import { render, staticRenderFns } from "./Roleplayers.vue?vue&type=template&id=6345301f&"
import script from "./Roleplayers.vue?vue&type=script&lang=js&"
export * from "./Roleplayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports